<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="p19"></a><h1 class="part-number"><span><a href="#/toc#toc-part001">P<span class="small-caps1">ART</span> I</a></span></h1>
<h1 class="part-title"><span><a href="#/toc#toc-part001">The Belle of Ávila</a></span></h1>
<p class="image1"><span><img alt="image" height="71" src="images/Art_Pcommon.jpg" width="108"/></span></p>
<a id="p20"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?9dec7cbc